// Single source of truth (frontend) for routing/access decisions.
// Mirrors the backend helpers (has_paid_access / submagic_satisfied).

// Admin-grandfathered (activated) OR an active/trialing Stripe subscription.
export const hasPaidAccess = (user) =>
    !!user &&
    (user.activated === true ||
        ["active", "trialing"].includes(user.subscription_status));

// Full Dashboard gate. Umbrella mode: every customer processes on ReelFlo's
// shared Submagic account, so paid access is the only gate.
export const hasDashboardAccess = (user) => hasPaidAccess(user);

// Where should we send this user right now?
export const nextRouteForUser = (user) => {
    if (!hasPaidAccess(user)) return "/subscribe";
    return "/dashboard";
};
